export default "__VITE_ASSET__Dr1ML$QR__"